const initialState = {
  listActions: [],
  totalActions: 0,
  listAnswers: [],
  totalAnswers: 0,
  infoAction: {},
  infoAnswer: {},
};

export default initialState;



// WEBPACK FOOTER //
// ./src/store/modules/trash/initialState.js